import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// ── THEME 1: LIGHT (Slate surface, Indigo primary) ──────────────────────────
export const LightPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
    colorScheme: {
      light: {
        surface: {
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.200}',
            300: '{slate.300}',
            400: '{slate.400}',
            500: '{slate.500}',
            600: '{slate.600}',
            700: '{slate.700}',
            800: '{slate.800}',
            900: '{slate.950}',
            950: '#f8faff',
          },
          primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}',
          },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.700}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.400}',
          700: '{slate.700}',
          800: '{slate.600}',
          900: '{slate.800}',
          950: '{slate.900}',
        },
        primary: {
            0: '#ffffff',
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.700}',
            300: '{slate.300}',
            400: '{slate.300}', 
            500: '{slate.500}',
            600: '{slate.400}',
            700: '{slate.500}',
            800: '{slate.600}',
            900: '{slate.800}',
            950: '{slate.900}',
          }
      }
    }
  },
  components: {
    card: { root: { borderRadius: '0.75rem' } },
  }
});

// ── THEME 2: CLAUDE DARK BROWN (Charcoal/Ambers) ────────────────────────────
// export const DarkBrownPreset = definePreset(Aura, {
//   semantic: {
//     primary: {
//       50: '{amber.50}',
//       100: '{amber.100}',
//       200: '{amber.200}',
//       300: '{amber.300}',
//       400: '{amber.400}',
//       500: '{amber.500}',
//       600: '{amber.600}',
//       700: '{amber.700}',
//       800: '{amber.800}',
//       900: '{amber.900}',
//       950: '{amber.950}',
//     },
//     colorScheme: {
//       light: {
//         surface: {
//           0: '#ffffff',
//           50: '{stone.50}',
//           100: '{stone.100}',
//           200: '{stone.200}',
//           300: '{stone.300}',
//           400: '{stone.400}',
//           500: '{stone.500}',
//           600: '{stone.600}',
//           700: '{stone.700}',
//           800: '{stone.800}',
//           900: '{stone.900}',
//           950: '{stone.950}',
//         }
//       },
//       dark: {
//         surface: {
//           0: '#18130f', // warm near-black (Claude UI)
//           50: '{stone.950}',
//           100: '{stone.900}',
//           200: '{stone.800}',
//           300: '{stone.700}',
//           400: '{stone.600}',
//           500: '{stone.500}',
//           600: '{stone.400}',
//           700: '{stone.300}',
//           800: '{stone.200}',
//           900: '{stone.100}',
//           950: '{stone.50}',
//         }
//       }
//     }
//   },
//   components: {
//     card: { root: { borderRadius: '0.75rem' } },
//   }
// });

// ── THEME 3: DARK BLUE (Claude darkness, cyan/blue shifted) ──────────────────
// export const DarkBluePreset = definePreset(Aura, {
//   semantic: {
//     primary: {
//       50: '{cyan.50}',
//       100: '{cyan.100}',
//       200: '{cyan.200}',
//       300: '{cyan.300}',
//       400: '{cyan.400}',
//       500: '{cyan.500}',
//       600: '{cyan.600}',
//       700: '{cyan.700}',
//       800: '{cyan.800}',
//       900: '{cyan.900}',
//       950: '{cyan.950}',
//     },
//     colorScheme: {
//       light: {
//         surface: {
//           0: '#ffffff',
//           50: '{zinc.50}',
//           100: '{zinc.100}',
//           200: '{zinc.200}',
//           300: '{zinc.300}',
//           400: '{zinc.400}',
//           500: '{zinc.500}',
//           600: '{zinc.600}',
//           700: '{zinc.700}',
//           800: '{zinc.800}',
//           900: '{zinc.900}',
//           950: '{zinc.950}',
//         }
//       },
//       dark: {
//         surface: {
//           0: '#0d1929',
//           50: '{slate.950}',
//           100: '{slate.900}',
//           200: '{slate.800}',
//           300: '{slate.700}',
//           400: '{slate.600}',
//           500: '{slate.500}',
//           600: '{slate.400}',
//           700: '{slate.300}',
//           800: '{slate.200}',
//           900: '{slate.100}',
//           950: '{slate.50}',
//         }
//       }
//     }
//   },
//   components: {
//     card: { root: { borderRadius: '0.75rem' } },
//   }
// });